<template>

  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from '@Sys~/components/mixins/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions({ xAxisData, legendData, seriesData } = {}) {
      this.chart.setOption({
        title: {
          text: "",
        },
        xAxis: {
          data: xAxisData,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            rotate: 0,
            color: "darkgray",
            formatter: function (value, idx) {
                var date = new Date(value);
                return idx === 0 ? value : [date.getMonth() + 1, date.getDate()].join('-');
            }
          },
        },
        yAxis: {
          axisTick: {
            show: false
          },
          axisLine: {
            show: false
          },
          splitArea: {
            show: false
          },
          axisLabel: {
            color: "darkgray"
          }
        },
        grid: {
          left: 10,
          right: 10,
          // bottom: 50,
          bottom: 5,
          top: 30,
          containLabel: true
        },
        legend: {
          data: legendData,
        },
        series: seriesData,
        tooltip: {
          trigger: 'axis',
          // axisPointer: {
          //   type: 'cross'
          // },
          padding: [5, 10]
        },
        // toolbox: {
        //     left: 'right',
        //     feature: {
        //         dataZoom: {
        //             yAxisIndex: 'none'
        //         },
        //         magicType: {
        //             type: ['line', 'bar', 'stack', 'tiled']
        //         },
        //         restore: {},
        //         saveAsImage: {}
        //     }
        // },
        // dataZoom: [{
        //     startValue: '1',
        //     type: 'slider',
        //     bottom: 10,
        // }],
      }, true)
    }
  }
}
</script>